// * ========================================================================
// * Ajax form functionality
// *
// * This handles ALL ajax form submits
// * ========================================================================

import getToken from '../api/token';
import { updateToken } from '../api/token';
import { showValidationErrors, hideErrors, setFormLoader, removeFormLoader, inputFilteringEvents } from '../util/form';
import { formValidationEvents } from '../util/form-validation';

function submit(form, callback) {
	setFormLoader(form);
	hideErrors(form);

	const action = form.dataset.action || form.getAttribute('action');
	const method = form.getAttribute('method');
	const formData = new FormData(form);

	const tokenPromise = method === 'POST' ? getToken() : Promise.resolve({ token: null });
	tokenPromise.then((token) => {
		if (token) {
			formData.set('token', token);
		}

		fetch(action, {
			method: method,
			cache: 'no-cache',
			body: formData
		}).then(response => {
			if (!response.ok) {
				throw new Error('Network response error.');
			}
			return response.json();
		}).then(async res => {
			if (res.errors && res.errors.length) {
				showValidationErrors(form, res.errors);

				if (typeof callback === 'function') {
					await callback(false, form, res);
				}
			} else if (res.success) {
				if (typeof callback === 'function') {
					await callback(true, form, res);
				}
			}

			removeFormLoader(form);

			if (res.token) {
				updateToken(res.token);
			}
			return res;
		}).catch(async () => {
			console.log('fail');
			if (typeof callback === 'function') {
				await callback(false, form, null);
			}
			removeFormLoader(form);
		});
	});
}

function initAjaxForm(selector = '.js-ajax-form') {
	const ajaxForms = document.querySelectorAll(selector);
	for (let form of ajaxForms) {
		if (form.classList.contains('ajax-form-initialized')) {
			continue;
		}

		form.classList.add('ajax-form-initialized');

		let callback = null;
		try {
			callback = form.dataset.callback ? eval(form.dataset.callback) : null;
		} catch(e) { /** this is fine */ }

		inputFilteringEvents(form);
		formValidationEvents(form);

		form.addEventListener('submit', (e) => {
			e.preventDefault();

			submit(form, callback);
		});
	}
}

function ajaxForm(API) {
	API.log('INIT ajaxForm');
	API.ajaxForm = initAjaxForm;
}

export { initAjaxForm, ajaxForm };
